import styled from 'styled-components';
import type { Variant } from './IconButton.component';

export const IconButton = styled.button<{ $variant: Variant }>`
  background-color: ${({ theme, $variant }) =>
    $variant === 'neutral' ? theme.colors['neutral-30'] : 'transparent'};
  width: 20px;
  height: 20px;
  border: 1px solid
    ${({ theme, $variant }) =>
      $variant === 'neutral' ? theme.colors['neutral-30'] : theme.colors['primary-60']};
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover:not(:active) {
    background-color: ${({ theme, $variant }) =>
      $variant === 'neutral' ? theme.colors['neutral-20'] : 'transparent'};
    border-color: ${({ theme, $variant }) =>
      $variant === 'neutral' ? theme.colors['neutral-40'] : 'rgb(106, 146, 233)'};

    & svg {
      fill: ${({ theme, $variant }) =>
        $variant === 'neutral' ? theme.colors['neutral-100'] : 'rgb(106, 146, 233)'};
    }
  }

  & svg {
    width: 12px;
    fill: ${({ theme, $variant }) =>
      $variant === 'neutral' ? theme.colors['neutral-100'] : theme.colors['primary-60']};
  }

  &:disabled {
    background-color: ${(props) => props.theme.colors['neutral-30']};
    border-color: ${(props) => props.theme.colors['neutral-30']};

    svg {
      width: 12px;
      fill: ${({ theme }) => theme.colors['neutral-60']};
      color: ${({ theme }) => theme.colors['neutral-60']};
    }
  }
`;
